<template>
  <div>
    <Header></Header>

    <div class="banner edu">
      <h2>
        <span>E</span>du-<span>T</span>ech <span>a</span>s <span>Service</span>
      </h2>
      <p>
        기술을 통해 최고의 교육 효과성을 만들고<br />
        교육시장의 실험과 Vision을 제시합니다.
      </p>

      <ul class="edu_list">
        <li class="edu_service">
          <img src="@/assets/img/edu_service.png" alt="Service" />
          <h3>Service</h3>
          <p>
            · 22년 운영서비스 분석을 통한 맞춤 교육<br />
            · 믿을 수 있는 운영품질 및 노하우
          </p>
        </li>
        <li class="edu_cont">
          <img src="@/assets/img/edu_cont.png" alt="Contents" />
          <h3>Contents</h3>
          <p>
            · 기업 맞춤 직무/기술 컨텐츠 개발<br />
            · 분야별 개발 전문인력 자체 보유
          </p>
        </li>
        <li class="solution">
          <img src="@/assets/img/edu_solution.png" alt="Solutions" />
          <h3>Solutions</h3>
          <p>
            · 기업 맞춤형 플랫폼 기획/개발<br />
            · 데이터 분석을 통한 맞춤 학습 피드백
          </p>
        </li>
      </ul>
    </div>

    <div class="tech_item">
      <div>
        <h2><img src="@/assets/img/i_mooc.png" alt="i:MOOC" /></h2>
        <p>퍼스널 러닝의 맞춤형 큐레이션 플랫폼</p>
        <strong>i:MOOC가 제안하는<br />완벽한 이러닝 솔루션</strong>
        <ul>
          <li><strong>현업 적용도</strong> 높은 컨텐츠!</li>
          <li>
            보기만 하는 강의 NO!<br />
            <strong>AI Speaking으로 말하기 훈련까지!</strong>
          </li>
          <li>
            언제·어디서든 학습 가능한<br />
            <strong>편리한 교육 환경!</strong>
          </li>
        </ul>
        <button @click="moveRouter('/imooc')" class="fb-bold pointer">
          바로가기
        </button>
      </div>
      <div class="center">
        <h2><img src="@/assets/img/ai.png" alt="AI튜터!" /></h2>
        <p>구글이 인정한 똑똑한 영어회화 솔루션</p>
        <strong>기술력과 학습 컨텐츠<br />모두를 검증 받다!</strong>
        <ul>
          <li>2020 한국영어교육학회 인증</li>
          <li>2019 Google Top Partner<br />Advisory Board 초청</li>
          <li>2019 대한민국 모바일 어워드<br />우수상 수상</li>
        </ul>
        <button @click="moveRouter('/aitutor')" class="pointer">
          바로가기
        </button>
      </div>
      <div>
        <h2>맞춤 컨텐츠</h2>
        <p>맞춤 컨텐츠로 학습을 일터의 흐름속으로!</p>
        <strong>글로벌 역량강화<br />자사 맞춤 컨텐츠 개발</strong>
        <ul>
          <li><strong>직무/기술/산업 별</strong> 맞춤 컨텐츠 개발!</li>
          <li>
            <strong>현업적용도를 높인</strong> 자사만의 특화된 컨텐츠를
            효과적으로 학습
          </li>
        </ul>
        <button @click="moveRouter('/custom-cont')" class="pointer">
          바로가기
        </button>
      </div>
    </div>

    <div class="tech_qa">
      <div class="inner">
        <h2>문의하기</h2>
        <p>
          B2B 교육 및 솔루션에 대한 문의를 남겨주시면 담당자가 확인 후
          <span class="pc_enter">최대한 빠른 시간 내에 연락드리겠습니다.</span>
          <strong
            >(혹시 이미 교육을 받고 계신 학습자이신가요?
            <a
              class="pointer"
              @click="newPage('http://carrotenglish.kr/phone/main_new/contact')"
              >Click!</a
            >)</strong
          >
        </p>
        <div class="qa_table">
          <div>
            <h3>회사명</h3>
            <input
              type="text"
              class="tech input"
              v-model="inquiryData.company"
            />
          </div>
          <div>
            <h3>담당자명</h3>
            <input
              type="text"
              class="tech input"
              v-model="inquiryData.manager"
            />
          </div>
          <div>
            <h3>연락처</h3>
            <input type="text" class="tech input" v-model="inquiryData.phone" />
          </div>
          <div>
            <h3>이메일</h3>
            <input type="text" class="tech input" v-model="inquiryData.email" />
          </div>
          <div>
            <h3>유입경로</h3>
            <ul class="funnel-list">
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path1"
                  value="path1"
                  v-model="selectEnterPath"
                />
                <label for="path1" class="pointer">캐럿 담당자 미팅</label>
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path2"
                  value="path2"
                  v-model="selectEnterPath"
                />
                <label for="path2" class="pointer"
                  >캐럿 컨퍼런스 및 설명회 등 모임</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path3"
                  value="path3"
                  v-model="selectEnterPath"
                />
                <label for="path3" class="pointer"
                  >온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브,
                  블로그 등)</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path4"
                  value="path4"
                  v-model="selectEnterPath"
                />
                <label for="path4" class="pointer">인터넷 검색</label>
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path5"
                  value="path5"
                  v-model="selectEnterPath"
                />
                <label for="path5" class="pointer"
                  >캐럿글로벌 종합안내서 책자 및 사보 등 자료</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  name="path"
                  id="path6"
                  value="path6"
                  v-model="selectEnterPath"
                />
                <label for="path6" class="pointer"
                  >타사 담당자 및 전임자 등 지인 소개</label
                >
              </li>
              <li class="etc">
                <input
                  type="radio"
                  name="path"
                  id="path7"
                  value="path7"
                  v-model="selectEnterPath"
                />
                <label for="path7" class="pointer">기타</label>
                <input
                  v-show="selectEnterPath === 'path7'"
                  type="text"
                  name="enterPathText"
                  id="enterPathText"
                  class="etc-input"
                  placeholder="직접 입력"
                  v-model="selectEnterPathText"
                />
              </li>
            </ul>
          </div>
          <div class="qa_cont">
            <h3>문의사항</h3>
            <textarea
              class="textarea"
              placeholder="온라인·AI교육과정 문의합니다."
              v-model="inquiryData.contents"
            ></textarea>
          </div>
          <div class="qa_agree">
            <p>
              <input
                type="checkbox"
                id="agree_check"
                v-model="inquiryData.agree"
              />
              <label for="agree_check" class="check_label"
                >개인정보 수집 및 이용에 동의합니다.</label
              >
            </p>
            <button class="pointer" @click="saveInquiry()">확인</button>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Solutions/Header.vue";
import Footer from "@/components/Solutions/Footer.vue";
// import { mapMutations } from "vuex";
export default {
  components: { Header, Footer },
  created() {
    // this.setCurrentPath(this.$router.currentRoute.path);
  },
  data() {
    return {
      inquiryData: {
        category: "INBOUND",
        company: "", //고객사명
        manager: "", //담당자
        phone: "", //연락처
        email: "", //이메일
        contents: "", //내용
        agree: false,
        enterPath: "", //유입경로
        enterPathText: "", // 기타입력
        enterUrl: window.location.href, //사이트주소
      },
      selectEnterPath: "",
      selectEnterPathText: "",
      pathValue: [
        { key: "path1", value: "캐럿 담당자 미팅" },
        { key: "path2", value: "캐럿 컨퍼런스 및 설명회 등 모임" },
        {
          key: "path3",
          value:
            "온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)",
        },
        { key: "path4", value: "인터넷 검색" },
        { key: "path5", value: "캐럿글로벌 종합안내서 책자 및 사보 등 자료" },
        { key: "path6", value: "타사 담당자 및 전임자 등 지인 소개" },
        { key: "path7", value: "기타" },
      ],
    };
  },
  mounted() {},
  methods: {
    // ...mapMutations({
    //   setCurrentPath: "setCurrentPath",
    // }),
    newPage(path) {
      window.open(path, "_blank");
    },
    moveRouter(path) {
      location.href = path;
      // this.$router.push(path).catch(() => {});
      // this.setCurrentPath(path);
      // this.isMenu = false;
    },
    saveInquiry() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "company" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "manager" && !this.inquiryData[key]) {
          alert("담당자명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "contents" && !this.inquiryData[key]) {
          alert("내용을 입력해주세요");
          flag = true;
          return;
        } else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (
        !this.inquiryData["enterPath"] &&
        !this.inquiryData["enterPathText"]
      ) {
        alert("유입경로를 선택 및 기타에 입력해주세요");
        flag = true;
        return false;
      }

      if (!flag) {
        const find = this.pathValue.find(
          (findItem) => findItem["key"] === this.inquiryData["enterPath"]
        );
        const pathText = find ? find["value"] : "";
        this.inquiryData["enterPath"] = pathText;

        this.axios
          .get("/rest/external/addSMP", { params: this.inquiryData })
          .then((res) => {
            if (res.data.err === 0) {
              alert("문의가 완료되었습니다.");
              this.inquiryData = {
                category: "INBOUND",
                company: "", //고객사명
                manager: "", //담당자
                phone: "", //연락처
                email: "", //이메일
                contents: "", //내용
                agree: false,
                enterPath: "",
                enterPathText: "",
                enterUrl: window.location.href, //사이트주소
              };

              this.selectEnterPath = "";
              this.selectEnterPathText = "";
            } else {
              alert(res.data.err_msg);
            }
          })
          .catch((err) => {
            console.error("err : ", err);
            alert("문의하기에 실패하였습니다.");
          });
      }
    },
  },

  watch: {
    selectEnterPath: function (val) {
      if (val === "path7") {
        this.inquiryData.enterPath = "";
      } else {
        this.inquiryData.enterPath = val;
        this.inquiryData.enterPathText = "";
        this.selectEnterPathText = "";
      }
    },

    selectEnterPathText: function (val) {
      this.inquiryData.enterPathText = val;
    },
  },
};
</script>

<style lang="scss">
.banner.edu {
  padding-bottom: 75px;
  background-image: url("~@/assets/img/edu_banner.png");
}

.banner.edu h2 {
  position: relative;
  padding: 148px 0 65px;
  font-size: 85px;
  font-weight: bold;
  color: #fff;
  letter-spacing: -2px;
}

.banner.edu h2::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 24px;
  width: 43px;
  height: 2px;
  margin: auto;
  background-color: #ff6600;
}

.banner.edu h2 span {
  color: #ff6600;
  font-weight: bold;
}

.banner.edu > p {
  font-weight: 300;
  font-size: 30px;
  color: #fff;
  line-height: 1.59;
}

.edu_list {
  padding-top: 73px;
  font-size: 0;
  text-align: center;
}

.edu_list li {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 376px;
  height: 146px;
  padding: 18px 0 29px 90px;
  border-radius: 18px;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.46);
  box-sizing: border-box;
}

.edu_list li + li {
  margin-left: 36px;
}

.edu_list img {
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
}

.edu_list h3 {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
}

.edu_list p {
  padding-top: 8px;
  font-size: 17px;
  font-weight: 300;
  color: #fff;
  letter-spacing: -1px;
  line-height: 1.63;
}

.tech_item {
  padding: 122px 0 112px;
  font-size: 0;
  text-align: center;
}

.tech_item div {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 379px;
  height: 669px;
  border-radius: 29px;
  border: 2px solid #ff6803;
  box-shadow: 0px 26px 28.42px 0.58px rgba(0, 0, 0, 0.09);
  box-sizing: border-box;
}

.tech_item div + div {
  margin-left: 33px;
}

.tech_item h2 {
  padding: 39px 0 6px;
  font-size: 35px;
  letter-spacing: -0.5px;
  font-weight: bold;
  color: #252525;
}

.tech_item p {
  padding-bottom: 31px;
  letter-spacing: -1.2px;
  font-size: 22px;
  font-weight: 500;
  color: #252525;
}

.tech_item > div > strong {
  display: block;
  padding: 17px 0 26px;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: -1px;
  color: #252525;
  background-color: #f5f5f5;
}

.tech_item ul {
  padding: 42px 33px 0 37px;
  text-align: left;
}

.tech_item li {
  padding-left: 28px;
  font-size: 20px;
  letter-spacing: -1.5px;
  font-weight: 500;
  color: #252525;
  background: url("~@/assets/img/orange_check.png") 0 3px no-repeat;
}

.tech_item li + li {
  margin-top: 24px;
}

.tech_item li strong {
  color: #ff6600;
}

.tech_item button {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 38px;
  width: 300px;
  height: 58px;
  margin: auto;
  border-radius: 29px;
  line-height: 56px;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: -1px;
  color: #fff;
  background-color: #ff6600;
  box-sizing: border-box;
}

.tech_item > div.center {
  background: url("~@/assets/img/tech_item_bg.png") center no-repeat;
  border-color: transparent;
  background-size: cover;
}

.tech_item > div.center h2 {
  padding-bottom: 6px;
}

.tech_item > div.center h2 img {
  display: block;
  margin: 9px auto 0;
}

.tech_item > div.center p {
  color: #fff;
}

.tech_item > div.center > strong {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.05);
}

.tech_item > div.center li {
  color: #aa8a5f;
  background: url("~@/assets/img/orange_check_off.png") 0 5px no-repeat;
}

.tech_item > div.center button {
  background-color: transparent;
  border: 1px solid #ff6600;
  color: #ff6600;
}

.tech_qa {
  background-color: #f5f5f5;
}

.qa_table div.qa_cont {
  position: absolute;
  right: 0;
  top: 3px;
  padding: 0;
  width: 555px;
}

.qa_table div.qa_cont h3 {
  position: static;
  padding-bottom: 15px;
  transform: translateY(0);
}

.textarea {
  width: 100%;
  height: 250px;
  padding: 17px 22px;
  border: 1px solid #252525;
  border-radius: 8px;
  font-size: 20px;
  letter-spacing: -1px;
  box-sizing: border-box;
}

.qa_table div.qa_agree {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0;
  width: 555px;
}

// .qa_agree {
//   padding-top: 10px;
//   text-align: right;
//   font-size: 0;
// }

// .qa_agree p,
// .qa_agree button {
//   display: inline-block;
//   vertical-align: middle;
// }

.tech.input {
  width: 100%;
  height: 47px;
  padding: 0 22px;
  border: 1px solid #252525;
  border-radius: 8px;
  font-size: 20px;
  letter-spacing: -1px;
  box-sizing: border-box;
}

.funnel-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  li {
    display: flex;
    align-items: center;
    gap: 0 5px;

    label {
      font-size: 13px;
      color: #000000;
    }

    input[type="radio"] {
      width: auto;
      margin-bottom: 0;
    }

    input[type="text"] {
      width: auto;
      font-size: 13px;
      color: #ffffff;
      margin-bottom: 0;
    }

    &.etc {
      width: 100%;

      .etc-input {
        color: #000000;
        border-radius: 4px;
        border: 1px solid #252525;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .banner.edu {
    padding-bottom: 40px;
    background: url("~@/assets/img/m/edu_banner.png") center no-repeat;
    background-size: cover;
  }

  .banner.edu h2 {
    padding: 34px 0 41px;
    font-size: 45px;
    line-height: 1.102;
    letter-spacing: 0;
  }

  .banner.edu h2::after {
    bottom: 10px;
    width: 30px;
    height: 1px;
    background-color: #ff6600;
  }

  .banner.edu > p {
    font-size: 18px;
    line-height: 1.4;
    letter-spacing: -1px;
  }

  .edu_list {
    padding-top: 38px;
  }

  .edu_list li {
    position: relative;
    display: block;
    width: calc(100% - 85px);
    margin: auto;
    max-width: 288.5px;
    height: auto;
    min-height: 77px;
    border-radius: 9px;
    padding: 20px 10px 17px 85px;
  }

  .edu_list li + li {
    margin-left: 0;
    margin: auto;
    margin-top: 12px;
  }

  .edu_list img {
    display: none;
  }

  .edu_list h3 {
    position: absolute;
    left: 0;
    bottom: 18px;
    width: 86.5px;
    text-align: center;
    font-size: 14px;
  }

  .edu_list h3::before {
    content: "";
    display: block;
    margin: 0 auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .edu_list li.edu_service h3::before {
    width: 21.5px;
    height: 21.5px;
    background-image: url("~@/assets/img/edu_service.png");
  }

  .edu_list li.edu_cont h3::before {
    width: 19px;
    height: 22px;
    background-image: url("~@/assets/img/edu_cont.png");
  }

  .edu_list li.solution h3::before {
    width: 20px;
    height: 20px;
    background-image: url("~@/assets/img/edu_solution.png");
  }

  .edu_list p {
    padding-top: 0;
    font-size: 12px;
  }

  .tech_item {
    padding: 33px 20px 49px;
  }

  .tech_item div {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 27.5px;
    padding-bottom: 117.5px;
    border: 1px solid #ff6803;
  }

  .tech_item div + div {
    margin-left: 0;
    margin-top: 45px;
  }

  .tech_item h2 {
    padding: 35px 0 8px;
    font-size: 31px;
  }

  .tech_item h2 img {
    height: 26px;
  }

  .tech_item p {
    padding-bottom: 22px;
    letter-spacing: -1.2px;
    font-size: 18.5px;
  }

  .tech_item > div > strong {
    display: block;
    padding: 20px 0 26px;
    font-size: 24px;
  }

  .tech_item ul {
    padding: 32.5px 33px 0 30px;
  }

  .tech_item li {
    padding-left: 27px;
    font-size: 18px;
    letter-spacing: -1.5px;
    background: url("~@/assets/img/m/orange_check.png") 3px 8px no-repeat;
    background-size: 18px;
  }

  .tech_item li + li {
    margin-top: 16px;
  }

  .tech_item button {
    bottom: 32.5px;
    width: calc(100% - 66px);
    height: 51.5px;
    border-radius: 25.8px;
    line-height: 50px;
    font-size: 18.5px;
  }

  .tech_item > div.center h2 {
    padding-bottom: 10px;
  }

  .tech_item > div.center h2 img {
    height: 31.5px;
  }

  .tech_item > div.center ul {
    padding-top: 28.5px;
  }

  .tech_qa .inner {
    width: 100%;
    padding: 22.5px 19px 100px;
  }

  .tech_qa h2 {
    font-size: 24px;
    padding-bottom: 6px;
  }

  .tech_qa > .inner > p {
    padding-bottom: 18px;
    font-size: 15px;
    line-height: 1.3;
  }

  .tech_qa > .inner > p strong {
    padding-top: 7px;
    font-size: 13px;
  }

  .qa_table div {
    padding: 3px 0 3px 57.5px;
    width: 100%;
  }
  .tech.input {
    height: 26px;
    padding: 0 10px;
    border-radius: 4px;
    font-size: 14px;
  }

  .qa_table div.qa_cont {
    position: static !important;
    padding-top: 15px !important;
    width: 100% !important;
  }

  .qa_table div.qa_agree {
    bottom: -45px;
  }

  .textarea {
    height: 91px;
    padding: 10px;
    border-radius: 4px;
  }
}
</style>
